export default __webpack_public_path__ + "static/media/prosper-cobra-erisa.7cc0bd3a.svg";